module.exports = __webpack_public_path__ + "static/img/12.936644b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/4/zh/12.png
// module id = ukEJ
// module chunks = 0